export const ASSETS_ENROLLED_OR_LOCKED_FILTER_NEW = "/assets?filter[]=needs_attention,is,true";

export const ASSETS_ENROLLED_OR_LOCKED_FILTER_LEGACY =
  "/assets?filter_link_operator=OR&filter[]=enrolled_status,is_any_of,enrolled,Enrolled&filter[]=security_level,not_in,Unlocked";

export function assetsEnrolledOrLockedFilterPath(assetsNewFiltersEnabled: boolean | undefined, withPagination = false) {
  const path = assetsNewFiltersEnabled ? ASSETS_ENROLLED_OR_LOCKED_FILTER_NEW : ASSETS_ENROLLED_OR_LOCKED_FILTER_LEGACY;

  if (!withPagination) return path;

  return path.replace("/assets?", "/assets?page[number]=1&page[size]=25&");
}
